
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M5 27.19V2.81h15l5 5v19.38H5z"}}),_c('g',{attrs:{"stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M13.12 16.88h2.5a3.13 3.13 0 000-6.26h-2.5M13.13 10.63h-1.88M13.13 10.63v6.25M13.13 16.88v4.37M13.13 21.25h-1.88M15 21.25h-1.87"}})])])])
          )
        }
      }
    